export const keys: (keyof CreateCampaignObjectiveBasedFormData)[] = [
  'name',
  'daily_budget',
  'start_at',
  'is_always_on',
  'end_at'
]

export const validator = (
  formData: Partial<CreateCampaignObjectiveBasedFormData>
) => {
  if (
    !!formData['name'] &&
    !!formData['daily_budget'] &&
    !!formData['start_at'] &&
    (!!formData['is_always_on'] || !!formData['end_at'])
  ) {
    return true
  }

  return false
}
